/* unplugin-vue-components disabled */import script from "./RoleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCard.vue?vue&type=script&setup=true&lang=js"

import "./RoleCard.vue?vue&type=style&index=0&id=5e0baaef&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0baaef"]])

export default __exports__